import { PAYMENT_MODEL_ENUM } from '@nxsys/constants/AppEnums';
import { useAsync } from '@nxsys/hooks/useAsync';
import { getPaymentStatisticsApi } from '@nxsys/services/api/statistics';
import { AppState } from '@nxsys/store';
import { GetPaymentStatisticsResponse } from '@nxsys/types/api/statistics';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useGetPaymentStatistics = () => {
  const { user, isBureauEmployer } = useSelector(
    (state: AppState) => state.appStore,
  );
  const { value, loading, error, run } = useAsync<GetPaymentStatisticsResponse>(
    () =>
      getPaymentStatisticsApi({
        ...(isBureauEmployer
          ? {
              companyRefs: user?.companyUserIds || [],
              paymentModels: [PAYMENT_MODEL_ENUM.PAYEE, PAYMENT_MODEL_ENUM.CIS],
            }
          : {}),
      }),
  );

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
